module.exports = "<div class=\"modal-body flex-column flex-align-center\">\n  <p class=\"text-align-center fs-16\">\n      {{ text }}\n  </p>\n  <div class=\"mt-15\">\n    <button *ngIf=\"redirect\" class=\"btn btn-lg btn-success mr-20\" (click)=\"closeModal(true)\">Go to Payment Methods</button>\n    <button class=\"btn btn-lg btn-default\" (click)=\"closeModal(false)\">{{ redirect ? 'Not Now' : 'Got it' }}</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.html
// module id = ./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.html
// module chunks = 0